/**
 * Collection Navigation — auto-scroll active elements into view.
 * Scrolls the active category pill (Layer 1) and active subcategory link (Layer 4)
 * to the horizontal center of their scroll containers on mobile.
 * After positioning, adds .cs-scroll-ready to reveal the containers (opacity 0 → 1).
 */
(function () {
  function scrollActiveToCenter(containerSelector, activeSelector) {
    const active = document.querySelector(activeSelector);
    if (!active) return;
    const scroller = active.closest(containerSelector);
    if (!scroller || scroller.scrollWidth <= scroller.clientWidth) return;
    const scrollerRect = scroller.getBoundingClientRect();
    const activeRect = active.getBoundingClientRect();
    const scrollTarget = active.offsetLeft - (scrollerRect.width / 2) + (activeRect.width / 2);
    scroller.scrollLeft = Math.max(0, scrollTarget);
  }

  function revealAll(selector) {
    for (const el of document.querySelectorAll(selector)) {
      el.classList.add('cs-scroll-ready');
    }
  }

  function init() {
    scrollActiveToCenter('.cs-cat-pills', '.cs-cat-pills__pill--active');
    /* Scroll each subcategory-links container that has an active link */
    for (const container of document.querySelectorAll('.cs-subcategory-links')) {
      const active = container.querySelector('.cs-subcategory-links__link--active');
      if (!active || container.scrollWidth <= container.clientWidth) continue;
      const containerRect = container.getBoundingClientRect();
      const activeRect = active.getBoundingClientRect();
      const scrollTarget = active.offsetLeft - (containerRect.width / 2) + (activeRect.width / 2);
      container.scrollLeft = Math.max(0, scrollTarget);
    }
    revealAll('.cs-cat-pills');
    revealAll('.cs-subcategory-links');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
